
import img0 from './Images/Install_1.png';
import img1 from './Images/Install_2.png';
import img2 from './Images/Install_3.png';
import img3 from './Images/Install_4.png';
import img4 from './Images/Install_5.png';
  
const content = `# Install SecureFile on Windows
  
The OnData SecureFile release package for Windows comes with one installation file named \`SecureFileInstaller.exe\`.
  
After obtaining the release package from OnData, you can extract it and run the \`SecureFileInstaller.exe\` inside to install the SecureFile product. 
Please note that administrative access to the operating system is required to install the OnData SecureFile product.  
  
Below is the list of steps to install the product on Windows.  
a. Ensure you have logged in with an administrative account to your computer and you do not have any other applications running.  
  
b. Double click on the \`SecureFileInstaller.exe\` after extracting the package. You will be prompted to allow the SecureFile installer to make 
changes to your system. Please note that the \`Verified publisher\` is \`OnData, Inc.\`  
  
![Confirmation Screen](${ img0 })  
  
c. Select \`Yes\` to continue. On the next screen select a folder where the application should be installed. It is recommended to use the default path.  
  
![Installation Folder](${ img1 })  

d. Click on \`Next\` and the following screen will be displayed. You have the option to create a desktop shortcut if preferred. Select \`Next\` to continue.  
  
![Desktop Shortcut](${ img2 })  
  
e. The following summary screen will be displayed before the installation actually starts. Select \`Install\` to proceed with the installation.  
  
![Summary Screen](${ img3 })  
  
f. The installation process will start and run till completion. At the end of the installation, the following screen is displayed. Click on the 
\`Finish\` button to complete the installation process.     
  
![Finish Screen](${ img4 })  
  
**Note**: If your computer does not have the Microsoft Visual C++ 14 Runtime Libraries installed, it may automatically install the Visual C++ 14 
Runtime Libraries from Microsoft. If your computer does not have the Microsoft .NET Runtime 8.x installed, it may automatically install the 
Microsoft .NET Desktop Runtime 8.x component as well.   
  
g. The installer may or may not ask you for a system reboot. If a system reboot is required, please choose to reboot your system.  
  
h. After the SecureFile product is installed, you can proceed to the instructions in [Register SecureFile](reference_doc#securefile/installation_and_configuration/register_securefile) to register 
your SecureFile instance with the OnData Portal.  
  
  `
  
export default content;
